import React from "react";
import PointOfSaleCore from "../../components/PointOfSale/Core/index";
import RestaurantCallCenter from "./RestaurantCallCenter";
import useAuthStore from "../../stores/useAuthStore";

const CallCenter = () => {
  const tillData = useAuthStore((s) => s.tillData);
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  return tillaccess.pos === "Y" ? <PointOfSaleCore component={RestaurantCallCenter} /> : <h1>Access Denied</h1>;
};

export default CallCenter;
